"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'Here you has a label and a click behavior.';
var code = "import React from 'react';\nimport { Button } from 'jsc-react-ui';\n\nconst AppBarExample = () => (\n  <Button onClick={() => alert('Button clicked')}>Click me</Button>\n);";
exports.LabelAndClickExampleButton = function () { return (React.createElement(common_1.Example, { title: "Label and Click", description: description, code: code },
    React.createElement(components_1.Button, { onClick: function () { return alert('Button clicked'); } }, "Click me"))); };
exports.LabelAndClickExampleButton.displayName = 'LabelAndClickExampleButton';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentButtonPage/LabelAndClickExampleButton.tsx
// module id = 636
// module chunks = 0